import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "max-height d-flex flex-d-c max-width" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ion-text-wrap cart-supplier-name" }
const _hoisted_4 = { slot: "content" }
const _hoisted_5 = { class: "ml-2 fw-b" }
const _hoisted_6 = {
  class: "purple-purple-color",
  style: {"height":"50px","width":"50px"}
}
const _hoisted_7 = { class: "ml-2 fw-b" }
const _hoisted_8 = { class: "ml-2 mt-3 mb-4 fw-b" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { slot: "footer" }
const _hoisted_11 = {
  key: 2,
  class: "purple-purple-color center-safe flex-d-c flex-grow-2"
}
const _hoisted_12 = {
  key: 3,
  class: "max-size center"
}

import { ref as _ref } from 'vue';

import {
    IonAccordion,
    IonAccordionGroup,
    IonAvatar,
    IonCol,
    IonGrid,
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonProgressBar,
    IonRow,
    IonSelectOption,
    IonSpinner,
    IonText,
    modalController,
    popoverController,
} from "@ionic/vue";
import { computed, onBeforeUnmount, onMounted, reactive, ref } from "vue";
import router, { ROUTE_NAME } from "@/router";
import { t } from "@/plugins/vue-i18n";
import { useDebounceFn } from "@vueuse/core";

import ButtonBase from "@/components/button/ButtonBase.vue";
import CartDetailsSliding from "@/components/various/CartDetailsSliding.vue";
import ButtonDelete from "@/components/button/ButtonDelete.vue";
import ScanModal from "@/components/modal/ScanModal.vue";
import SelectSimple from "@/components/selects/SelectSimple.vue";

import { useUserStore } from "@/stores/user";
import { useListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";
import { usePersistentStore } from "@/stores/persistent";
import { useNotificationStore } from "@/stores/notification";

import { popAlertConfirm } from "@/functions/alert";
import { interactionFeedbackToast } from "@/functions/baseToast";
import { isApp } from "@/functions/enviroment";

import { PERMISSION_KEY } from "@/types/user";
import { CartData, CartList, Supplier } from "@/types/supplier";
import { KIND } from "@/types/enum/supplierEnum";
import { SelectTouchEvent } from "@/types/frontend/event";

import { warningOutline } from "ionicons/icons"
import MessagePopover from "@/components/popover/MessagePopover.vue";
import { DateTime } from "luxon";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor, PluginListenerHandle } from "@capacitor/core";
import HighlightBox from "@/components/card/HighlightBox.vue";
import { HIGHLIGHT_COLOR, HIGHLIGHT_MESSAGE } from "@/types/enum/propEnum";
import { useLoader } from "@/composables/useLoader";
import LinkText from "@/components/textSnippet/LinkText.vue";
import { PROMOTION_TYPE } from "@/types/enum/notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShoppingCart',
  props: {
    cartData: {}
  },
  emits: ["next"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const userStore = useUserStore()
const listStore = useListStore()
const supplierStore = useSupplierStore()
const persistentStore = usePersistentStore()
const notificationStore = useNotificationStore()

const { showLoading, hideLoading } = useLoader()

let loading = _ref(false)
const locationId = _ref(router.currentRoute.value.params.locationId as string)
const scanSupplier = ref<Supplier | undefined>(undefined)
const debounceChangeAmount = ref<boolean>(false)
const openList = ref<string>(listStore.cartLists.length === 1 ? listStore.cartLists[0]?.supplier?.id : '')
let currentItem = reactive<{ id: string; amount: number }>({ id: '', amount: 0 })
const containsExpired = (list: CartData): boolean => {
    for (const item of list.cartItems) {
        if (!item.promotion || !item.promotion.validUntil) continue
        if (DateTime.fromISO(item.promotion.validUntil).diffNow('minutes').minutes < 0) return true
    }
    return false
}

const toggleAccordion = (supplierId: string): void => {
    if (openList.value === supplierId) {
        openList.value = ''
        return
    }
    openList.value = supplierId
}

const disableCartListOrder = (cartList: CartData): boolean => {
    return !userStore.sessionInfo.emailConfirmed
        || (!cartList.supplier.email && cartList.supplier.kind !== KIND.ONLINE)
        || debounceChangeAmount.value
        || !userStore.permission[PERMISSION_KEY.ORDER_CREATE]
        || containsExpired(cartList)
        || persistentStore.noConnection
}

// const locationId = computed<string>(() => String(router.currentRoute.value.params.locationId))
const isScanAvailable = computed<boolean>(() => userStore.permission[PERMISSION_KEY.CART_ADD] && !persistentStore.offlineMode && isApp() && !!supplierStore.allSuppliers.find(supplier => supplier.scannerActivated))
// const orderedLists = computed<Array<List>>(() => {
//     const lists = listStore.lists?.data as Array<List>;
//     return lists?.length > 1
//         ? lists.reduce((slicedList: Array<List>, list: List) => {
//             if (!slicedList.find(({ supplierId }) => supplierId === list.supplierId)) slicedList.push(list)
//             return slicedList;
//         }, [])
//         : lists ?? [];
// })

const showPromoPill = (cartList: CartData): boolean => {
    return cartList.summary.some((i) => {
        const promotion = i.item.promotion
        const product = notificationStore.findPromotionProduct(promotion?.id, promotion?.productId)

        return i.isPromotion || (i.item.promotion?.promotionType !== PROMOTION_TYPE.BONUS_FLEXIBLE && Number(i.quantity) < Number(product?.stepAmount))
    })
}

const cartItemAmount = (item: CartData): void | number => {
    return item.supplier?.totalCartPosition
}

const orderAmountList = (item: CartData): number => {
    return item.supplier?.totalCartItems
}

const resetDebounce = (itemId: string) => {
    debounceChangeAmount.value = false
    if (itemId === currentItem.id) currentItem = {
        id: '',
        amount: 0
    }
}

const disableOnPatch = async (amount: any, itemId: string): Promise<void> => {
    if (!currentItem) {
        currentItem = { id: itemId, amount }
    }
    if (currentItem.id && currentItem.id !== itemId) {
        patchItem(currentItem.amount, currentItem.id)
        currentItem = { id: itemId, amount }
    }
    debounceChangeAmount.value = true
    await debouncePatchItem(amount, itemId)
}

const patchItem = async (amount: number, itemId: string): Promise<void> => {
    if (!amount) return

    const response = await listStore.patchCartItem(locationId.value, itemId, amount)

    if (!response) return

    await listStore.getShoppingCart(locationId.value)

    resetDebounce(itemId)
}

const debouncePatchItem = useDebounceFn(patchItem, 500)

const deleteList = async (list: CartList): Promise<void> => {
    popAlertConfirm({
        message: t('alert.delete.cartList', { target: list.name }),
        handler: {
            ok: async () => {
                const response = await listStore.deleteCartList(locationId.value, list.id)

                if (response) {
                    await listStore.getShoppingCart(locationId.value)
                }
            }
        }
    })
}

const deleteNoListItems = async (supplierId: string): Promise<void> => {
    popAlertConfirm({
        message: t('alert.delete.noList'),
        handler: {
            ok: async () => {
                await showLoading()
                await listStore.deleteNoListItems(locationId.value, supplierId)
                setTimeout(async () => {
                    await listStore.getShoppingCart(locationId.value)
                    await hideLoading()
                }, 250)
            }
        }
    })
}

const deleteCart = async (cartData: CartData) => {
    await showLoading()
    await listStore.deleteFullCart(locationId.value, cartData.supplier.id)

    setTimeout(async () => {
        await listStore.getShoppingCart(locationId.value)
        await hideLoading()
    }, 250)
}

const deleteCartCheck = (cartData: CartData) => {
    popAlertConfirm({
        message: t('alert.delete.cartSupplier', { target: cartData.supplier.name }),
        handler: {
            ok: () => deleteCart(cartData)
        }
    })
}

const goToSupplierSettings = (supplierId: string): void => {
    if (!supplierId) return
    router.push({ name: ROUTE_NAME.EDIT_CUSTOM_SUPPLIER, params: { supplierId: supplierId } })
    modalController.dismiss()
}

const resendMail = async (): Promise<void> => {
    const response = await userStore.resendConfirmationMail()

    if (response) await interactionFeedbackToast(true, {
        type: 'resendMail',
        id: 'resend-register-mail'
    })
}

const chooseListId = (): void => {
    // use querySelector, because if we take from ref open() method doesn't work
    const listSelect: SelectTouchEvent | null = document.querySelector('#list-select')

    if (listSelect) listSelect.open()
}
const openScanModel = async (): Promise<void> => {
    const modal = await modalController.create({
        component: ScanModal,
        componentProps: {
            supplierId: scanSupplier.value?.id,
        },
        cssClass: 'scanner-modal'
    })
    scanSupplier.value = undefined
    modal.onDidDismiss()
    await modal.present()
}
const getSupplierName = (supplierId: string): string | undefined => {
    return supplierStore.allSuppliers.find(supplier => supplier.id === supplierId)?.name
}

const showDisableReason = async (event: MouseEvent | TouchEvent, cartList: CartData) => {
    let popoverElement: HTMLIonPopoverElement | undefined = undefined

    if (!userStore.permission[PERMISSION_KEY.ORDER_CREATE]) popoverElement = await popoverController.create({
        component: MessagePopover,
        componentProps: {
            message: t('messages.missingCartOrderPermission')
        },
        arrow: true,
        cssClass: 'message-popover w-500px',
        showBackdrop: false,
        alignment: 'end',
        side: 'bottom',

        event
    })

    if (containsExpired(cartList)) popoverElement = await popoverController.create({
        component: MessagePopover,
        componentProps: {
            message: t('messages.containsExpiredPromotion')
        },
        arrow: true,
        cssClass: 'message-popover w-500px',
        showBackdrop: false,
        alignment: 'end',
        side: 'bottom',

        event
    })

    if (!popoverElement) return

    await popoverElement.present()

    setTimeout(() => {
        if (!popoverElement) return
        popoverElement.dismiss()
    }, 5000)
}

let keyboardListener: PluginListenerHandle | null = null
if (Capacitor.isNativePlatform()) {
    keyboardListener = Keyboard.addListener('keyboardDidShow', () => {
        window.addEventListener('click', (ev) => {
            ev.preventDefault()
            ev.stopPropagation()
            Keyboard.hide()
            document.activeElement.blur()
        }, { once: true })
    })
}

onBeforeUnmount(() => {
    keyboardListener?.remove()
    keyboardListener = null
})

onMounted(async () => {
    loading.value = true
    await Promise.all([
        notificationStore.getPromotions({ locationId: locationId.value }),
        listStore.getShoppingCart(locationId.value),
        userStore.getMe(),
        supplierStore.getLocationDeliveryDays(locationId.value)
    ])
    loading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: {"height":"7px"},
      class: _normalizeClass({ 'grey4-grey4-background': _unref(listStore).cartLists.length > 0 || isScanAvailable.value })
    }, [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_unref(IonProgressBar), {
            key: 0,
            class: "max-height",
            type: "indeterminate",
            color: "medium"
          }))
        : _createCommentVNode("", true)
    ], 2),
    (isScanAvailable.value)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 0,
          class: "grey4-grey4-background",
          onClick: chooseListId
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "d-flex center-y px-3" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonImg), {
                  src: "/assets/icon/barcode.svg",
                  class: "scan-icon"
                }),
                _createVNode(_unref(IonText), { class: "fs-smaller purple-purple-color ml-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('messages.addProductsViaScanner')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(SelectSimple, {
                  id: "list-select",
                  modelValue: scanSupplier.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((scanSupplier).value = $event)),
                  options: _unref(supplierStore).allSuppliers.filter(supplier => supplier.scannerActivated),
                  onChange: openScanModel
                }, {
                  options: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supplierStore).allSuppliers.filter(supplier => supplier.scannerActivated), (supplier) => {
                      return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                        key: supplier.id,
                        value: supplier
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(supplier.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (!_unref(userStore).sessionInfo.emailConfirmed)
        ? (_openBlock(), _createBlock(_unref(IonGrid), {
            key: 0,
            style: {"color":"darkgoldenrod"},
            class: "grey4-grey4-background pb-1 flex-grow-0 max-width"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), {
                    size: "2",
                    class: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        class: "fs-28",
                        icon: _unref(warningOutline)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('messages.register.validateEmail')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { class: "center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("u", { onClick: resendMail }, _toDisplayString(_ctx.$t('button.resend')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(listStore).cartLists.length > 0)
        ? (_openBlock(), _createBlock(_unref(IonAccordionGroup), {
            key: 1,
            value: openList.value,
            multiple: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listStore).cartLists, (cartList) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: cartList.supplier.id,
                  class: "cart mt-1"
                }, [
                  _createVNode(_unref(IonAccordion), {
                    value: cartList.supplier.id,
                    class: "light-light-background"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), {
                        slot: "header",
                        class: "grey4-grey4-background accordion-90-deg cart-header",
                        lines: "none",
                        onClick: _withModifiers(($event: any) => (toggleAccordion(cartList.supplier.id)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonAvatar), {
                            slot: "start",
                            style: {"min-height":"64px","min-width":"64px","margin-top":"5px"}
                          }, {
                            default: _withCtx(() => [
                              (cartList.supplier.imageLink)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    alt: "",
                                    src: (cartList.supplier.imageLink.startsWith('/')) ? `https://app.octopusorder.com${cartList.supplier.imageLink}` : cartList.supplier.imageLink,
                                    class: "card-border max-height of-contain"
                                  }, null, 8, _hoisted_2))
                                : (cartList.supplier.iconType)
                                  ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                      key: 1,
                                      src: `assets/icon/${cartList.supplier.iconType}.svg`,
                                      class: "max-size purple-purple-color"
                                    }, null, 8, ["src"]))
                                  : (_openBlock(), _createBlock(_unref(IonIcon), {
                                      key: 2,
                                      src: "assets/icon/deliverer.svg",
                                      class: "max-size purple-purple-color"
                                    }))
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(IonLabel), { style: {"--color":"var(--ion-color-purple)"} }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('messages.cart.selectionFrom', { deliverer: cartList.supplier.name })), 1),
                              (showPromoPill(cartList))
                                ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonCol), {
                                        size: "auto",
                                        class: "pt-1 p-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(HighlightBox, {
                                            color: _unref(HIGHLIGHT_COLOR).CORAL
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t(`enumT.${_unref(HIGHLIGHT_MESSAGE).PROMOTION}`)), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["color"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(IonGrid), { class: "no-padding-grid-only purple-purple-color light-light-background" }, {
                          default: _withCtx(() => [
                            (cartList.lists.length)
                              ? (_openBlock(), _createBlock(_unref(IonRow), {
                                  key: 0,
                                  class: "mt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('messages.cart.fromList')) + ":", 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonCol), { size: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(LinkText, {
                                          onClick: ($event: any) => (deleteCartCheck(cartList)),
                                          class: "active-link-click"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('button.deleteSupplierCart')), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartList.lists, (list) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: list.name
                              }, [
                                _createVNode(_unref(IonRow), { class: "my-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), {
                                      size: "auto",
                                      class: "center-y px-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createVNode(_unref(IonIcon), {
                                            src: "assets/icon/list.svg",
                                            class: "max-size"
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonCol), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonRow), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonCol), { class: "purple-purple-color" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(cartList.supplier.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_unref(IonRow), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonCol), {
                                              class: "fw-b",
                                              size: "auto"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(list.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            (list.isDeleted)
                                              ? (_openBlock(), _createBlock(_unref(IonCol), { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(HighlightBox, {
                                                      color: _unref(HIGHLIGHT_COLOR).CORAL
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('label.deleted')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["color"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (_unref(userStore).permission[_unref(PERMISSION_KEY).CART_DELETE])
                                      ? (_openBlock(), _createBlock(_unref(IonCol), {
                                          key: 0,
                                          size: "auto"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(ButtonDelete, {
                                              onClick: ($event: any) => (deleteList(list)),
                                              class: "danger-ripple"
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024),
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "line grey4-grey4-background" }, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.cartItems, (listItem) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: listItem.id
                                  }, [
                                    _createVNode(CartDetailsSliding, {
                                      entry: listItem,
                                      onAmount: ($event: any) => {listItem.quantity = $event ?? 0; disableOnPatch($event, listItem.id)},
                                      onEnable: ($event: any) => (resetDebounce(listItem.id)),
                                      edit: _unref(userStore).permission[_unref(PERMISSION_KEY).CART_UPDATE] || _unref(userStore).permission[_unref(PERMISSION_KEY).CART_DELETE]
                                    }, null, 8, ["entry", "onAmount", "onEnable", "edit"]),
                                    _cache[1] || (_cache[1] = _createElementVNode("div", {
                                      class: "line grey4-grey4-background ml-3",
                                      style: {"width":"calc(100% - 2rem)"}
                                    }, null, -1))
                                  ], 64))
                                }), 128))
                              ], 64))
                            }), 128)),
                            (cartList.cartItems.length)
                              ? (_openBlock(), _createBlock(_unref(IonRow), {
                                  key: 1,
                                  class: "pt-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), { class: "center-y" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('messages.cart.noList')) + ":", 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(IonCol), { size: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(ButtonDelete, {
                                          onClick: ($event: any) => (deleteNoListItems(cartList.supplier.id)),
                                          class: "danger-ripple"
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartList.cartItems.filter((i) => !i.orderId), (noListItem, index) => {
                              return (_openBlock(), _createBlock(CartDetailsSliding, {
                                key: noListItem.id,
                                entry: noListItem,
                                edit: _unref(userStore).permission[_unref(PERMISSION_KEY).CART_UPDATE] || _unref(userStore).permission[_unref(PERMISSION_KEY).CART_DELETE],
                                "no-top": index === 0,
                                onAmount: ($event: any) => {noListItem.quantity = $event ?? 0; disableOnPatch($event, noListItem.id)},
                                onEnable: ($event: any) => (resetDebounce(noListItem.id))
                              }, null, 8, ["entry", "edit", "no-top", "onAmount", "onEnable"]))
                            }), 128)),
                            (cartList.cartItems.filter((i) => i.orderId).length)
                              ? (_openBlock(), _createBlock(_unref(IonRow), {
                                  key: 2,
                                  class: "pt-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), { class: "center-y" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('messages.cart.lastOrder')) + ":", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartList.cartItems.filter((i) => i.orderId), (lastOrderItem, index) => {
                              return (_openBlock(), _createBlock(CartDetailsSliding, {
                                key: lastOrderItem.id,
                                entry: lastOrderItem,
                                edit: _unref(userStore).permission[_unref(PERMISSION_KEY).CART_UPDATE] || _unref(userStore).permission[_unref(PERMISSION_KEY).CART_DELETE],
                                "no-top": index === 0,
                                onAmount: ($event: any) => {lastOrderItem.quantity = $event ?? 0; disableOnPatch($event, lastOrderItem.id)},
                                onEnable: ($event: any) => (resetDebounce(lastOrderItem.id))
                              }, null, 8, ["entry", "edit", "no-top", "onAmount", "onEnable"]))
                            }), 128)),
                            (!cartList.supplier.email && cartList.supplier.kind !== _unref(KIND).ONLINE)
                              ? (_openBlock(), _createBlock(_unref(IonGrid), {
                                  key: 3,
                                  style: {"color":"darkgoldenrod"},
                                  class: "grey4-grey4-background pb-1 flex-grow-0 max-width"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonRow), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonCol), {
                                          size: "2",
                                          class: "center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonIcon), {
                                              class: "fs-28",
                                              icon: _unref(warningOutline)
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonCol), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('messages.deliverer.noEmail')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_unref(userStore).permission[_unref(PERMISSION_KEY).SUPPLIER_CREATE])
                                      ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonCol), { class: "center" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("u", {
                                                  onClick: ($event: any) => (goToSupplierSettings(cartList.supplier.id))
                                                }, _toDisplayString(_ctx.$t('titleRoute.editLocationDeliverer')), 9, _hoisted_9)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_unref(IonRow), { class: "grey4-grey4-background py-2 fs-smaller grey1-grey1-color" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonRow), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.amountItems', { amount: orderAmountList(cartList) })), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_unref(IonRow), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonCol), { class: "py-0 center-y" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.amount', { amount: cartItemAmount(cartList) })), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            (_unref(userStore).permission[_unref(PERMISSION_KEY).ORDER_REQUEST])
                              ? (_openBlock(), _createBlock(_unref(IonCol), {
                                  key: 0,
                                  size: "auto",
                                  class: "ion-justify-content-end d-flex ion-align-items-center",
                                  onClick: ($event: any) => (showDisableReason($event, cartList))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(ButtonBase, {
                                      disabled: disableCartListOrder(cartList),
                                      class: "max-height m-0",
                                      onClick: ($event: any) => (emit('next', cartList))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('button.orderOverview')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"]),
                  _createVNode(_unref(IonRow), { class: "grey4-grey4-background p-1 fs-smaller grey1-grey1-color" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonRow), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.amountItems', { amount: orderAmountList(cartList) })), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(IonRow), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), { class: "py-0 center-y" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.amount', { amount: cartItemAmount(cartList) })), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (_unref(userStore).permission[_unref(PERMISSION_KEY).ORDER_REQUEST])
                        ? (_openBlock(), _createBlock(_unref(IonCol), {
                            key: 0,
                            size: "auto",
                            class: "ion-justify-content-end d-flex ion-align-items-center",
                            onClick: ($event: any) => (showDisableReason($event, cartList))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ButtonBase, {
                                disabled: disableCartListOrder(cartList),
                                class: "max-height m-0",
                                onClick: ($event: any) => (emit('next', cartList))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('button.orderOverview')), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"]))
        : (!_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('messages.emptyCart')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_unref(IonSpinner), {
                color: "medium",
                style: {"--color":"var(--ion-color-purple)"}
              })
            ]))
    ])
  ], 64))
}
}

})